/* eslint-disable */
import React, { useEffect, useState } from 'react';
import './style.scss';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import exclamation from '../../assets/images/exclamation.png';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import Picker from 'react-mobile-picker';
import { generateTimeOptions } from 'src/onboarding/helpers/generateTimeOptions';
interface PickerValue {
  start: string;
  finish: string;
}

function Page() {
  const eatHours = useStore((state) => state.eatHours);
  const setEatHours = useStore((state) => state.setEatHours);

  const setEatingWindow = useStore((state) => state.setEatingWindow);
  const [notification, setNotification] = useState(null);

  const [pickerValue, setPickerValue] = useState<PickerValue>({
    start: eatHours?.start || '8:00 AM',
    finish: eatHours?.finish || '6:00 PM',
  });

  const [userInteracted, setUserInteracted] = useState(false);

  const { onNext, onPrev, currentIndex } = useNav();

  useEffect(() => {
    setEatHours(pickerValue);
    calculateEatingWindow(pickerValue);
  }, [pickerValue]);

  const handleUserInteraction = () => {
    setUserInteracted(true);
  };

  useEffect(() => {
    const savedNotification = localStorage.getItem('eatHoursNotification');
    if (savedNotification && userInteracted) {
      setNotification(JSON.parse(savedNotification));
    }
  }, [userInteracted]);

  useEffect(() => {
    const handleTouchMove = (event: TouchEvent) => {
      if (document.querySelector('.time-picker_new')?.contains(event.target as Node)) {
        event.preventDefault();
      }
    };

    document.addEventListener('touchmove', handleTouchMove, { passive: false });

    return () => {
      document.removeEventListener('touchmove', handleTouchMove);
    };
  }, []);

  const handleChange = (newValue) => {
    if (!userInteracted) handleUserInteraction();
    setPickerValue(newValue);
  };

  const calculateEatingWindow = ({ start, finish }) => {
    const parseTime = (timeStr: string) => {
      if (!timeStr || typeof timeStr !== 'string') return { hours: 0, minutes: 0 };

      const parts = timeStr.trim().split(' ');
      if (parts.length !== 2) {
        return { hours: 0, minutes: 0 };
      }

      const [time, modifier] = parts;
      const [h, m] = time.split(':');
      let hours = parseInt(h, 10);
      const minutes = parseInt(m, 10);

      if (modifier === 'PM' && hours !== 12) hours += 12;
      if (modifier === 'AM' && hours === 12) hours = 0;

      return { hours, minutes };
    };

    const startTime = parseTime(start);
    const finishTime = parseTime(finish);

    const startMinutes = startTime.hours * 60 + startTime.minutes;
    const finishMinutes = finishTime.hours * 60 + finishTime.minutes;

    let diffMinutes = finishMinutes - startMinutes;
    if (diffMinutes < 0) diffMinutes += 24 * 60;

    const totalHours = parseFloat((diffMinutes / 60).toFixed(1));
    setEatingWindow(totalHours);
    if (userInteracted) {
      determineNotification(totalHours);
    }
  };

  const determineNotification = (eatingWindow) => {
    let newNotification = null;

    if (eatingWindow < 8) {
      newNotification = {
        title: t('onboarding.eatHours.notifications.lessEightHours.title'),
        message: t('onboarding.eatHours.notifications.lessEightHours.description'),
        type: 'warning',
      };
    } else if (eatingWindow >= 8 && eatingWindow <= 10) {
      newNotification = {
        title: t('onboarding.eatHours.notifications.lessTenHours.title'),
        message: t('onboarding.eatHours.notifications.lessTenHours.description'),
        type: 'warning',
      };
    } else if (eatingWindow >= 11 && eatingWindow <= 12) {
      newNotification = {
        title: t('onboarding.eatHours.notifications.lessTwelveHours.title'),
        message: t('onboarding.eatHours.notifications.lessTwelveHours.description'),
        type: 'warning',
      };
    } else if (eatingWindow >= 13) {
      newNotification = {
        title: t('onboarding.eatHours.notifications.moreThirteenHours.title'),
        message: t('onboarding.eatHours.notifications.moreThirteenHours.description'),
        type: 'warning',
      };
    }

    if (newNotification) {
      setNotification(newNotification);
      localStorage.setItem('eatHoursNotification', JSON.stringify(newNotification));
    }
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.eatHours.title')}</Title>
      </div>

      <div className={'controls controls_new'}>
        <div className='picker-labels'>
          <Text size='m' medium>
            {t('onboarding.eatHours.start')}
          </Text>
          <Text size='m' medium>
            {t('onboarding.eatHours.finish')}
          </Text>
        </div>

        <div className='time-picker'>
          <Picker
            value={pickerValue}
            onChange={handleChange}
            wheelMode='natural'
            height={150}
            className={'time-picker_new'}
            itemHeight={40}
          >
            <Picker.Column name='start' className='col'>
              {generateTimeOptions().map((start) => (
                <Picker.Item key={start} value={start} className='item'>
                  {({ selected }) => (
                    <div className={selected ? 'item_selected' : 'item_neutral'}>{start}</div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
          </Picker>

          <Picker
            value={pickerValue}
            onChange={handleChange}
            wheelMode='natural'
            height={150}
            className={'time-picker_new'}
            itemHeight={40}
          >
            <Picker.Column name='finish' className='col'>
              {generateTimeOptions().map((finish, index) => (
                <Picker.Item key={finish} value={finish} className='item'>
                  {({ selected }) => (
                    <div className={selected ? 'item_selected' : 'item_neutral'}>{finish}</div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
          </Picker>
        </div>

      </div>

      {notification && (
        <div className={`notification ${notification.type}`}>
          {
            <div className={'title-container'}>
              {notification.type !== 'normal' && (
                <img className={'exclamation'} src={exclamation} />
              )}
              <Text size='s' semibold style={{ textAlign: 'left' }}>
                {notification.title}
              </Text>
            </div>
          }
          <Caption className={'notification-description'}>{notification.message}</Caption>
        </div>
      )}

      <div className={'next-wrapper'}>
        <Button
          title={t('onboarding.eatHours.continue')}
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'eat-hours',
              answer: eatHours,
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
